
shadow$export("default",orgx.about_dynamic_adding_to_classpath_in_clojure.component);
shadow$export("component",orgx.about_dynamic_adding_to_classpath_in_clojure.component);